export default __webpack_public_path__ + "static/media/equipments.fc3b5c57.jpg";